import { styled } from '@mui/material/styles'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid';
import Typography from "@mui/material/Typography";

export const Container = styled(Box)`
  display: flex;
  align-items: center;
  flex-direction: column;
  height: auto;

  

  /* @media(max-width: 800px){
    padding-top: 0;
  } */
`



